export default __webpack_public_path__ + "static/media/Track alumni bg.14093298.png";